import {apiURl} from './apiconfig'

const getCodeRequest = (email) => {
    const GET_CODE_API_ENDPOINT = apiURl + 'verifications/sendEmail?email=' + email.email.email;
    
    const parameters = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(email.email)
    };
    return fetch(GET_CODE_API_ENDPOINT, parameters)
    .then(response => {
        const statusCode = response.status;
        const data = response.json();
        return Promise.all([statusCode, data]);
    })
    .catch(error => {
        return error;
    });
};

const changePasswordRequest = ({payload}) => {

  const CHANGE_PASSWORD_API_ENDPOINT = apiURl + 'users/passwordRecovery';
  const parameters = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload),   
  };
  return fetch(CHANGE_PASSWORD_API_ENDPOINT, parameters)
  .then(response => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
  })
  .then(([res]) => {
      return [res];
  })
  .catch(error => {
      return error;
  });
};

const getAllUsers = (token) => {
    const REGISTER_API_ENDPOINT = apiURl + 'users/getall';
    const parameters = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : 'Bearer ' + token,
      }
    };

    return fetch(REGISTER_API_ENDPOINT, parameters)
    .then(response => {
        const statusCode = response.status;
        const data = response.json();
        return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
        return [res, data];
    })
    .catch(error => {
        return error;
    });
};

const deleteUserRequest = (token, user) => {
    const DELETE_API_ENDPOINT = apiURl + 'users/delete';
    const parameters = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : 'Bearer ' + token,
      },
      body: JSON.stringify(user)
    };

    return fetch(DELETE_API_ENDPOINT, parameters)
    .then(response => {
        const statusCode = response.status;
        const data = response.json();
        return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
        return [res, data];
    })
    .catch(error => {
        return error;
    });
};

const updateUserRequest = (user, token) => {
    const EDIT_USER_API_ENDPOINT = apiURl + 'users/edit';
    // todo:  update organization picker to multi
    const parameters = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : 'Bearer ' + token,
      },
      body: JSON.stringify(user)
    };

    return fetch(EDIT_USER_API_ENDPOINT, parameters)
    .then(response => {
        const statusCode = response.status;
        const data = response.json();

    return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
        return [res, data];
    })
    .catch(error => {
        return error;
    });
};

export {
    getAllUsers,
    updateUserRequest,
    deleteUserRequest,
    getCodeRequest,
    changePasswordRequest
}